enum Product {
  CheckIn = 'check-in',
  LeadCapture = 'lead-capture',
}

export default Product;
